import axios from 'axios'
// axios.defaults.baseURL='https://mtest.mingshiedu.com/apis/network/'
export default axios



// WEBPACK FOOTER //
// ./src/api/axios.config.js